// Module
var code = "<span title=\"{{ $parent.row['interest-portion'] | number : 3 }}% of selected audience consumed {{ $parent.row['phrase'] }}\"\n      am-tooltip=\"top center to bottom center\"\n      am-tooltip-type=\"info\">\n    {{$parent.row['interest-portion'] | number : 3}}%\n</span>\n";
// Exports
module.exports = code;